import { Layout, Menu, Typography, Button } from 'antd';
import { TeamOutlined, PlusOutlined, LogoutOutlined } from '@ant-design/icons';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { usePlatformAuth } from '../utils/PlatformAuthContext';
import { useInactivityManager } from '../utils/InactivityManager';

const { Header, Sider, Content } = Layout;

const PlatformLayout = () => {
  const { user, logout } = usePlatformAuth();
  const location = useLocation();
  useInactivityManager(logout);

  const selectedKey = location.pathname.startsWith('/tenants/new')
    ? 'create'
    : 'tenants';

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider breakpoint="lg" collapsedWidth={0} theme="dark">
        <div style={{ padding: '16px', color: '#fff', fontWeight: 700 }}>RentAHAB Master</div>
        <Menu theme="dark" mode="inline" selectedKeys={[selectedKey]}>
          <Menu.Item key="tenants" icon={<TeamOutlined />}>
            <Link to="/tenants">Clientes</Link>
          </Menu.Item>
          <Menu.Item key="create" icon={<PlusOutlined />}>
            <Link to="/tenants/new">Nuevo cliente</Link>
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout>
        <Header
          style={{
            background: '#fff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 24px',
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <Typography.Text strong>Super Admin — {user?.name}</Typography.Text>
          <Button icon={<LogoutOutlined />} onClick={logout}>
            Cerrar sesión
          </Button>
        </Header>
        <Content style={{ margin: 24 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default PlatformLayout;
